import Vue from 'vue'
import * as truncate from 'truncate-html'

Vue.filter('truncateHtml', (value, size) => {
    return truncate.default(value, size)
})
